import { StyledBroadsiderInfo } from './BroadsiderInfo.styled';

const BroadsiderInfo = ({ broadsider, hideType = false }) => {
  return (
    <StyledBroadsiderInfo>
      <div>
        {!hideType && <span className='info-field'>{(broadsider && broadsider.isOg()) ? 'Broadside OG' : 'Basejump AF'}: </span>}
        <span>{broadsider ? broadsider.getName() : ''}</span>
      </div>
      <div>
        <span className='info-field'># </span>
        <span>{broadsider ? broadsider.getId() : ''}</span>
      </div>
    </StyledBroadsiderInfo>
  );
};

export default BroadsiderInfo;
